import { render, staticRenderFns } from "./AddOne.vue?vue&type=template&id=497fab56&"
import script from "./AddOne.vue?vue&type=script&lang=js&"
export * from "./AddOne.vue?vue&type=script&lang=js&"
import style0 from "./AddOne.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddOne.vue"
export default component.exports